module.exports = __webpack_public_path__ + "img/plr.b64df3cf.svg";